import { render, staticRenderFns } from "./ProductOptionsSection.vue?vue&type=template&id=1baa80b0"
import script from "./ProductOptionsSection.vue?vue&type=script&lang=js"
export * from "./ProductOptionsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports